module.exports = __webpack_public_path__ + "static/media/ios-contact.880cdcac.svg";